import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DTSelectActionReasonView, AVAILABLE_FIELDS_CONFIG } from '../../DTSelectActionReasonView';
import SelectInputs from '../../Common/SelectInputs/SelectInputs';
import { getActionReasons, getRefundReasonOptions } from '../../../../../../extractFromState';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';

const DTSelectRefundReasonNode = () => {
  const dispatch = useDispatch();

  const refundReasonOptions = useSelector(getRefundReasonOptions);
  const actionReasons = useSelector(getActionReasons);

  const handleNextButtonClick = () => dispatch(addEdgeToDecisionTreePath('reason_selected'));

  return (
    <DTSelectActionReasonView
      isNextButtonActive={actionReasons?.refundPrimaryReason}
      onNextButtonClick={handleNextButtonClick}
    >
      <SelectInputs
        placeholder="Select refund reason"
        options={refundReasonOptions}
        fields={AVAILABLE_FIELDS_CONFIG.refundReason}
      />
    </DTSelectActionReasonView>
  );
};

export default DTSelectRefundReasonNode;
